/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ImportAuditRow } from '../models/ImportAuditRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuditService {
    /**
     * Recent import audit rows (admin only)
     * Returns the 20 most recent import audit rows ordered by id descending.
     * Requires the `tps-admin` role; returns 403 otherwise.
     *
     * @returns any Recent audit rows.
     * @throws ApiError
     */
    public static listAudits(): CancelablePromise<{
        rows?: Array<ImportAuditRow>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/audits',
            errors: {
                401: `Missing or invalid bearer token.`,
                403: `Authenticated but not authorized for this operation.`,
            },
        });
    }
}
